export function formatQualification(qualification: HasQualificationName) {
    return `${qualification.regNumber} - ${qualification.title}`.trim();
}

interface HasQualificationName {
    title: string;
    regNumber: string;
}
